<template>
    <div class="analysis">
        <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-model-item v-for="(item,index) in lableList" :key="index" :label="item.label" :prop="item.key">
                <div v-if="item.type=='input'">
                    <a-input v-model="item.val" :placeholder="'请输入' + item.label">
                        <a-tooltip v-if="item.complain" slot="suffix" :title="item.complain || '无'">
                            <a-icon type="info-circle" style="color: rgba(0,0,0,.45);cursor:pointer;" />
                        </a-tooltip>
                    </a-input>
                </div>    
               <div v-if="item.type == 'select'">
                    <a-select style="width: 350px" v-model="item.val" :placeholder="'请选择' + item.label">
                       <a-select-option v-if="item.key=='projectId'" v-for="(ele,sort) in projectManageList" :key="sort" :value="ele.projectId">{{ ele.projectName }}</a-select-option>
                       <a-select-option v-if="item.key!='projectId'" v-for="(ele,sort) in renewalFlagList" :key="sort" :value="ele.id">{{ ele.label }}</a-select-option>
                    </a-select>
                    <a-tooltip placement="top" :title="item.complain || '无'">
                        <a-icon type="info-circle" style="color: rgba(0,0,0,.45);cursor:pointer;margin-left:10px;" />
                    </a-tooltip>
               </div>    
            </a-form-model-item>
       </a-form-model>
       <div style="width:100%;text-align:center;">
                <a-button type="primary" :loading="loading" @click="onSubmit" style="padding:0 50px;margin-right:30px;"> 提 交 </a-button>
                <a-button  @click="resetForm" style="padding:0 50px;">重置</a-button>
        </div>
    </div>    
</template>
<script>
const lableList= [
    { label:'现有项目',key:'projectId',type:"select",val:undefined,complain:''},
    { label:'现有房间数(个)',key:'houseNum',type:"input",val:null,complain:'收购当前的房间数量' },
    { label:'可增加房间数（个）',key:'expandHouseNum',type:"input",val:null,complain:'收购后可扩建的房间数量' },
    { label:'前期投资总额（万元）',key:'preInvesAmt',type:"input",val:null,complain:'被收购方前期对项目的投资总额' },
    { label:'负债（万元）',key:'deptAmt',type:"input",val:null,complain:'项目当前负债' },
    { label:'前一年租金（万元）',key:'lastYearRent',type:"input",val:null,complain:'收购项目前一年的场地租金' },
    { label:'租赁期限（年）',key:'rentLimitYear',type:"input",val:null,complain:'收购项目的场地租赁期限' },
    { label:'剩余租期（年）',key:'surplusRentYear',type:"input",val:null,complain:'合同剩余租赁期限' },
    { label:'可否续租',key:'renewalFlag',type:"select",val:undefined,complain:'租赁到期后能否续租' },
    { label:'前一年平均值（元）',key:'lastYearAvgAmt',type:"input",val:null,complain:'收购项目前一年平均房价' },
    { label:'出租率（百分比）',key:'lastYearRentalRate',type:"input",val:null,complain:'前一年的出租率' },
    { label:'客房GOP率（百分比)',key:'guestRoomGosRate',type:"input",val:null,complain:'客房营业毛利率' },
    { label:'餐饮日均营业额（元）',key:'caterAvgAmt',type:"input",val:null,complain:'若有餐饮收入，餐饮部分的日均营业额' },
    { label:'餐饮GOP额（百分比）',key:'caterGosRate',type:"input",val:null,complain:'餐饮营业毛利率' },
    { label:'酒店占比（百分比）',key:'hotelRate',type:"input",val:null,complain:'房间作为酒店运营的比例（默认为100%）' },
    { label:'ADR（元）',key:'adrAmt',type:"input",val:null,complain:'平均房价' },
    { label:'出租率（百分比）',key:'rentRate',type:"input",val:null,complain:'房间的出租率' },
    { label:'GOP率（百分比）',key:'gopRate',type:"input",val:null,complain:'营业毛利率' },
    { label:'月均房价（元）',key:'houseMonthAvgAmt',type:"input",val:null,complain:'以公寓形式出租，按月收取租金' },
    { label:'是否有餐饮',key:'caterFlag',type:"select",val:undefined,complain:'项目是否包含餐饮' },
    { label:'建筑面积（㎡）',key:'buildArea',type:"input",val:null,complain:'项目实际建筑面积' },
    { label:'合约期限（年）',key:'contractTerm',type:"input",val:null,complain:'项目租赁场地的合约期限' },
    { label:'免租期（年）',key:'freeRentYear',type:"input",val:null,complain:'免除租金的期限' },
    { label:'流转保证金（万元）',key:'depositAmt',type:"input",val:null,complain:'租赁场地所缴纳的流转保证金' },
    { label:'中介费（万元）',key:'intermediaryAmt',type:"input",val:null,complain:'租赁场地所缴纳的中介费' },
    { label:'转让费（万元）',key:'transferAmt',type:"input",val:null,complain:'场地二次转让所需的转让费用' },
    { label:'租金是否规则',key:'rentAmtInRule',type:"select",val:undefined,complain:'租金按合约比例固定递增' },
    { label:'稳定期（年）',key:'stableYear',type:"input",val:null,complain:'租金稳定不变的期限' },
    { label:'每（）年递增',key:'increaseYear',type:"input",val:null,complain:'租金递增的周期' },
    { label:'递增百分比',key:'increasePercent',type:"input",val:null,complain:'每次递增的百分比' },
    { label:'首年租金（万元）',key:'firstYearRentAmt',type:"input",val:null,complain:'租约合同生效首年所需租金' },
    { label:'预付月数（个月）',key:'prePayMonth',type:"input",val:null,complain:'规则租金预缴月数' },
    { label:'是否转租',key:'transferFlag',type:"select",val:undefined,complain:'是否将部分房间转租给其他项目' },
    { label:'改建成本（万元/间)',key:'reformCostAmt',type:"input",val:null,complain:'项目收购后对房间改建/扩建平均投入成本' },
    { label:'二次装修成本（万元/间）',key:'renovationAmt',type:"input",val:null,complain:'每件房间进行二次装修平均投入（8年周期）' },
    { label:'建设期（天）',key:'buildDay',type:"input",val:null,complain:'新建/装修所需期限' },
    { label:'开荒期（天）',key:'reclaimDay',type:"input",val:null,complain:'开荒工作投入期限' },
    { label:'联系人',key:'contactName',type:"input",val:null,complain:'' },
    { label:'联系方式',key:'contactPhone',type:"input",val:null,complain:'' },
   ]
    let rules = {};
        lableList.forEach(item=>{
            let arr = [];
            let obj1 = {};
            if(item.type == 'input'){
                obj1 = {
                        required: true,
                        message: "请输入" + item.label,
                        trigger: "blur", 
                    }
            }else{
                obj1 = {
                        required: true,
                        message: "请选择" + item.label,
                        trigger: "onchange", 
                    }
            }
            arr.push(obj1);
            rules[item.key] = arr;
        })
        rules.contactPhone[1] =  {
                pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
                message: '请输入正确的手机号',
                trigger: "blur", 
            }    
export default {
   data(){
       return{
            labelCol: { span: 8 },
            wrapperCol: { span: 16 },
            lableList:lableList,
            loading:false,
            form: {
                projectId:'',// 现有项目
                houseNum:'',//现有房间数(个)
                expandHouseNum:'',//可增加房间数（个）
                preInvesAmt:'',//前期投资总额（万元）
                deptAmt:'',//负债（万元）
                lastYearRent:'',//前一年租金（万元）
                rentLimitYear:'',//租赁期限（年）
                surplusRentYear:'',//剩余租期（年）
                renewalFlag:'',//可否续租
                lastYearAvgAmt:'',//前一年平均值（元）
                lastYearRentalRate:'',//前一年出租率（百分比）
                guestRoomGosRate:'',//客房营业毛利率
                caterAvgAmt:'',//餐饮日均营业额（元）
                caterGosRate:'',//餐饮GOP额（百分比）
                hotelRate:'',//酒店占比（百分比）
                adrAmt:'',//ADR（元）
                rentRate:'',//出租率（百分比）
                gopRate:'',//GOP率（百分比）
                houseMonthAvgAmt:'',//月均房价（元）
                caterFlag:'',//是否有餐饮
                buildArea:'',//建筑面积（㎡）
                contractTerm:'',//合约期限（年）
                freeRentYear:'',//免租期（年）
                depositAmt:'',//流转保证金（万元）
                intermediaryAmt:'',//中介费（万元）
                transferAmt:'',//转让费（万元）
                rentAmtInRule:'',//租金是否规则
                stableYear:'',//稳定期（年）
                increaseYear:'',//每（）年递增
                increasePercent:'',//递增百分比（百分比）
                firstYearRentAmt:'',//首年租金（万元）
                prePayMonth:'',//预付月数（个月）
                transferFlag:'',//是否转租
                reformCostAmt:'',//改建成本（万元/间)
                renovationAmt:'',//二次装修成本（万元/间）
                buildDay:'',//建设期
                reclaimDay:'',//开荒期
                contactName:'',//联系人
                contactPhone:'',
            },
            rules:rules,
            projectManageList:[],
            renewalFlagList:[
                { id:1,label:'是' },
                { id:0,label:'否' }
            ],
       }
   },
   created(){
       this.getProjectManageList();
       this.resetForm();
   },
   mounted(){
       this.$parent.current = '4';
   },
   watch:{
        lableList: {
            handler(newVal, oldVal) {
               newVal.forEach(item=>{
                   this.form[item.key] = item.val;
               })
            },
            deep: true
        }
   },
   methods:{
    getProjectManageList(){
        this.$https.get('/portal/project/projectForAnalyse').then(res=>{
             if(res.code == 200){
                 this.projectManageList = res.rows;
             }
        })
    },
    onSubmit(){
        this.$refs.ruleForm.validate((valid) => {
        if (valid) {
            this.loading = true;
          this.$https.post('/portal/analyse/addProjectAnalyse',this.form).then(res=>{
                this.loading = false;
                if(res.code == 200){
                    this.$message.success('保存成功，请前往项目管理查看')
                    this.resetForm();
                    this.getProjectManageList();
                }else{
                    this.$error(
                        { content: (<div><p>保存失败</p></div>),}
                    )
                }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },   
    resetForm() {
        this.form = {
                projectId:'',// 现有项目
                houseNum:'',//现有房间数(个)
                expandHouseNum:'',//可增加房间数（个）
                preInvesAmt:'',//前期投资总额（万元）
                deptAmt:'',//负债（万元）
                lastYearRent:'',//前一年租金（万元）
                rentLimitYear:'',//租赁期限（年）
                surplusRentYear:'',//剩余租期（年）
                renewalFlag:'',//可否续租
                lastYearAvgAmt:'',//前一年平均值（元）
                lastYearRentalRate:'',//前一年出租率（百分比）
                guestRoomGosRate:'',//客房营业毛利率
                caterAvgAmt:'',//餐饮日均营业额（元）
                caterGosRate:'',//餐饮GOP额（百分比）
                hotelRate:'',//酒店占比（百分比）
                adrAmt:'',//ADR（元）
                rentRate:'',//出租率（百分比）
                gopRate:'',//GOP率（百分比）
                houseMonthAvgAmt:'',//月均房价（元）
                caterFlag:'',//是否有餐饮
                buildArea:'',//建筑面积（㎡）
                contractTerm:'',//合约期限（年）
                freeRentYear:'',//免租期（年）
                depositAmt:'',//流转保证金（万元）
                intermediaryAmt:'',//中介费（万元）
                transferAmt:'',//转让费（万元）
                rentAmtInRule:'',//租金是否规则
                stableYear:'',//稳定期（年）
                increaseYear:'',//每（）年递增
                increasePercent:'',//递增百分比（百分比）
                firstYearRentAmt:'',//首年租金（万元）
                prePayMonth:'',//预付月数（个月）
                transferFlag:'',//是否转租
                reformCostAmt:'',//改建成本（万元/间)
                renovationAmt:'',//二次装修成本（万元/间）
                buildDay:'',//建设期
                reclaimDay:'',//开荒期
                contactName:'',//联系人m
                contactPhone:'',
            }
            this.lableList.forEach(item=>{
                if(item.type == 'select'){
                    item.val = undefined
                }else{
                    item.val = '';
                }
            }) 
       },
   }
}
</script>

<style lang="less" scoped>
.analysis{
    width: 1300px;
    margin:0 auto;
    background: #fff;
    padding:20px 20px 50px 20px;
    .ant-form{
        width: 100%;
        display: inline-block;
    }
    .ant-form-item{
        width: 46%;
        float: left;
        &:nth-of-type(even){margin-left: 8%;}
    }
    .ant-form-item-control-wrapper{
        position: relative;
        explain{
            position: absolute;
            top:0;
            right: 10px;
        }
    }
}
</style>